import styled from "styled-components";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { colors } from "@sonder/ui/source/styled/theme";

// Exports
export const PrimaryButton = styled(Button)`
  background: ${props => (props.selected ? colors.blue2 : colors.blue7)};
  border-color: ${props => {
    if (props.noBorder) return "transparent";
    if (props.selected) return colors.blue2;
    return colors.blue7;
  }};
  color: ${colors.white};

  &:hover:not(:disabled) {
    background: ${props => !props.selected && colors.blue7};
    border-color: ${colors.blue7};
  }

  &:active:not(:disabled) {
    background: ${colors.blue2};
    border-color: ${colors.blue2};
  }

  &:disabled {
    background: ${colors.blueA};
    border-color: ${colors.blueA};
    color: ${colors.white};
  }
`;
